import { SVGProps } from 'react';

export const CheckCircleIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg data-icon width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        className="fill-fletchers-gray-200"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 2.5C4.96243 2.5 2.5 4.96243 2.5 8C2.5 11.0376 4.96243 13.5 8 13.5C11.0376 13.5 13.5 11.0376 13.5 8C13.5 4.96243 11.0376 2.5 8 2.5ZM1.5 8C1.5 4.41015 4.41015 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 8ZM10.2906 6.09313C10.5153 6.25364 10.5674 6.56591 10.4069 6.79062L7.90687 10.2906C7.82144 10.4102 7.68772 10.4862 7.54124 10.4983C7.39476 10.5104 7.25037 10.4575 7.14645 10.3536L5.64645 8.85355C5.45118 8.65829 5.45118 8.34171 5.64645 8.14645C5.84171 7.95118 6.15829 7.95118 6.35355 8.14645L7.4362 9.22909L9.59313 6.20938C9.75364 5.98467 10.0659 5.93263 10.2906 6.09313Z"
      />
    </svg>
  );
};
